export const isSuccessResponse = (res, isNullable = false) => {
  return (
    res.status &&
    res.status >= 200 &&
    res.status < 300 &&
    (isNullable || (!isNullable && res.data?.data))
  );
};
